module.exports = __webpack_public_path__ + "static/media/remodulin.86c65993.PNG";